
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function BulimiaNervosa(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Bulimia nervosa"}></DetailHeader>

                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    <b>Bulimia nervosa</b>, also known as simply <b>bulimia</b>, is an <a href='https://en.wikipedia.org/wiki/Eating_disorder' className='links'>eating disorder</a> characterized by <a href='https://en.wikipedia.org/wiki/Binge_eating' className='links'>binge eating</a> followed
                                    by purging; and excessive concern with body shape
                                    and weight. The aim of this activity is to expel the body
                                    of calories eaten from the binging phase of the
                                    process. Binge eating refers to eating a large amount
                                    of food in a short amount of time. Purging refers to
                                    the attempts to get rid of the food consumed.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Bulimia-Nervosa/1.png")} alt="Bulimia-Nervosa" />
                                    </div>
                                </div>
                                <br></br>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <p>Being preoccupied with your body shape and weight</p>
                                <p>Living in fear of gaining weight</p>
                                <p>Repeated episodes of eating abnormally large amounts of food in one sitting</p>
                                <p>Feeling a loss of control during bingeing — like you can't stop eating or can't control what you eat</p>
                                <p>Forcing yourself to vomit or exercising too much to keep from gaining weight after bingeing</p>
                                <p>Using laxatives, diuretics or enemas after eating when they're not needed</p>
                                <p>Fasting, restricting calories or avoiding certain foods between binges</p>
                                <p>Using dietary supplements or herbal products excessively for weight loss</p>
                                <p>The severity of bulimia is determined by the number of times a week that you purge, usually at least once
                                    a week for at least three months.</p>


                                <a className="links" href="https://en.wikipedia.org/wiki/Bulimia_nervosa">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default BulimiaNervosa;